import { Component, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CompensatoryOffService } from '../../../Model/CompensatoryOff/compensatory-off.service';
import { SessionService } from '../../../Util/Session/session.service';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterOutlet, RouterModule } from '@angular/router';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-compensatory-off-form-popup',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, NgbDatepickerModule, FormsModule, JsonPipe, DataTablesModule, NgbDropdownModule, LoaderComponent],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './compensatory-off-form-popup.component.html',
  styleUrl: './compensatory-off-form-popup.component.scss'
})
export class CompensatoryOffFormPopupComponent {
  isDisabled: boolean = false;
  @Input() AttendanceDate: string = '';
  @Input() EmpMasterID: any = 0;
  EmployeeLeave = [];
  // EmpMasterId: any;
  user = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private activeModal: NgbActiveModal,
    private compensatoryOff: CompensatoryOffService,
    private session: SessionService,
    protected common: CommonService,
  ) {
    this.user = this.session.GetUserDetails();
    console.log(this.AttendanceDate);
    console.log(this.EmpMasterID);
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_EmployeeCompOffRaise_LoadLoad();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_EmployeeCompOffRaise_LoadLoad() {
    this.isDisabled = true;
    // this.compensatoryOff.ESS_EmployeeCompOffRaise_LoadLoad({ SelectType: 1, EmpMasterID: this.session.GetUserDetails().UserId, AttendanceDate: this.AttendanceDate }).subscribe({
    this.compensatoryOff.ESS_EmployeeCompOffRaise_LoadLoad({ SelectType: 1, EmpMasterID: this.EmpMasterID, AttendanceDate: this.AttendanceDate }).subscribe({
      next: (response) => {
        if (response.Table.length > 0) {
          this.EmployeeLeave = response.Table;
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Select(index: number) {
    this.activeModal.close(this.EmployeeLeave[index]);
  }

  close(result: boolean) {
    this.activeModal.close();
  }
}
